import BaseApi from '@garpix/base-api';
import { AxiosInstance } from 'axios'
import { getCookie, removeCookie, setCookie } from '@/utils'


abstract class AbstractApi extends BaseApi {
  AUTH_TOKEN_KEY: string

  constructor (MAIN_URL: string) {
    super(MAIN_URL)
    this.AUTH_TOKEN_KEY = 'auth_key'
  }

  setAuthToken = (token: string) => {
    setCookie(this.AUTH_TOKEN_KEY, token, 365);
    return true;
  };

  getAuthToken = () => {
    return getCookie(this.AUTH_TOKEN_KEY);
  };

  removeAuthToken = () => {
    try {
      removeCookie(this.AUTH_TOKEN_KEY);
      return true;
    } catch {
      return false; // no key
    }
  };

  /** Настройка перед отправкой запроса. Вызывается отдельно для каждого запроса.
   * @param axios Инстанс Axios.
   * @returns Инстанс Axios.
   */
  axiosOverride = (axios: AxiosInstance) => {
    const token = this.getAuthToken();

    if (token) {
      const authToken = `Bearer ${token}`;

      axios.defaults.headers.common['Authorization'] = authToken;
      axios.defaults.headers.common['X-Authorization'] = authToken;
    } else {
      delete axios.defaults.headers.common['Authorization'];
      delete axios.defaults.headers.common['X-Authorization'];
    }

    return axios;
  };
}

export default AbstractApi
